export const useRelationshipDiscoverer = (params, item, stack) => {
    const discover = (fullKey) => {
        if (!fullKey || typeof fullKey !== 'string') return null;
    
        const keys = fullKey.split('.');
        const rootKey = keys[0];
        let result = null;
        let source = null;

        // cerca rootKey in params
        if (params && params[rootKey] !== undefined) {
            result = params[rootKey];
            source = 'params';
        } 
        
        // cerca rootKey in item
        if (item && item[rootKey] !== undefined && !result) {
            result = item[rootKey];
            source = 'item';
        } 
        
        // cerca rootKey in stack
        if (stack && !result) {
            const found = stack.find(obj => Object.keys(obj)[0] === rootKey);
            if (found) {
                result = found[rootKey];
                source = 'stack';
            }
        }

        if (!result) return null;

        // 2. naviga ricorsivamente le chiavi rimanenti
        for (let i = 1; i < keys.length; i++) {
            if (result && typeof result === 'object' && !Array.isArray(result)) {
                // caso pietoso di person.employment
                if (fullKey == 'person.employment') {
                    let parent = result;
                    result = result[keys[i]];
                    result = { ...result, person: { _id: parent._id, firstname: parent.firstname, lastname: parent.lastname } }
                } else {
                    result = result[keys[i]];
                }
            } else if (result && Array.isArray(result)) {
                // cerca il primo elemento che contiene la chiave richiesta
                const match = result.find(entry => typeof entry === 'object' && entry && keys[i] in entry);
                result = match ? match[keys[i]] : null;
            } else {
                return null;
            }
        }

        return result;
    };

    // const discover = (key) => {
    //     let result;
    //     let keys;
    //     let location;
    //     let parent;

    //     if (key == 'employment.person') {
    //         //console.info('Blocca qui employment.person')
    //     }
    //     if (key == 'person.employment') {
    //         //console.info('Blocca qui person.employment')
    //     }
    //     if (key == 'legalEntity') {
    //         //console.info('Blocca qui legalEntity')
    //     }
    //     if (key == 'car') {
    //         //console.info('Blocca qui car')
    //     }

    //     if (key.includes('.')) {
    //         keys = key.split('.');
    //         key = keys[0];
    //     }

    //     if (params) {
    //         result = params[key] ?? null;

    //         if (result) {
    //             location = 'params';
    //             //console.info('useRelationshipDiscoverer: trovato', key, 'in ', location, params, result);
    //         }
    //     }

    //     if (!result && item) {
    //         result = item[key] ?? null;

    //         if (result) {
    //             location = 'item';
    //             //console.info('useRelationshipDiscoverer: trovato', key, 'in ', location, item, result);
    //         }
    //     }

    //     if (!result && stack) {
    //         result = stack.find(obj => Object.keys(obj)[0] === key)?.[key] ?? null;

    //         if (result) {
    //             location = 'stack';
    //             //console.info('useRelationshipDiscoverer: trovato', key, 'in ', location, stack, result);
    //         }
    //     }

    //     if (keys && result) {
    //         parent = result;
    //         // per ora accettiamo solo un annidamento
    //         result = result[keys[1]];
    //         //console.info('trovato result devo valutare annidamento', keys, parent, result);
    //     }

    //     if (Array.isArray(keys) && keys.join('.') === 'person.employment' && result) {
    //         //console.info('compilo person.employment', result, { ...result, person: { _id: parent._id, firstname: parent.firstname, lastname: parent.lastname } })
    //         result = { ...result, person: { _id: parent._id, firstname: parent.firstname, lastname: parent.lastname } }
    //     }

    //     return result;
    // }

    const discoverInStack = (key) => {
        return stack?.find(obj => Object.keys(obj)[0] === key)?.[key] ?? null;
    }

    const discoverAssignedModelForService = () => {
        if (discover('person.employment') ?? discover('employment')) return 'employee';
        if (discover('car')) return 'car';
        if (discover('contract')) return 'contract';
    }

    return {
        discover,
        discoverInStack,
        discoverAssignedModelForService
    }

};
